import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { ADMIN_PATHS, adminPath } from '../../constants/adminPaths';
import '../styles/adminLoginPage.css';

export default function AdminAccessCodePage({ onUnlock }) {
  const [unlockCode, setUnlockCode] = useState('');
  const [showUnlockCode, setShowUnlockCode] = useState(false);
  const [trustThisDevice, setTrustThisDevice] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleUnlock = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await onUnlock(unlockCode, { trustThisDevice });
    } catch (err) {
      setError(err?.message || 'Invalid security code. Access denied.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="adminLogin">
      <div className="adminLogin__bg" aria-hidden="true" />
      <main className="adminLogin__container">
        <section className="adminLogin__card" aria-label="Admin unlock">
          <header className="adminLogin__header">
            <div className="adminLogin__badge adminLogin__badge--warn" aria-hidden="true">
              Restricted
            </div>
            <h1 className="adminLogin__title">Access code</h1>
            <p className="adminLogin__subtitle">
              Enter the security code to continue to the admin login.
            </p>
          </header>

          <div className="adminLogin__divider" aria-hidden="true" />

          {error ? (
            <div className="adminLogin__alert" role="alert">
              <span className="adminLogin__alertDot" aria-hidden="true" />
              <span>{error}</span>
            </div>
          ) : null}

          <form className="adminLogin__form" onSubmit={handleUnlock}>
            <label className="adminLogin__label">
              <div className="adminLogin__inputWrap">
                <input
                  className="adminLogin__input adminLogin__input--withBtn adminLogin__input--secret"
                  type={showUnlockCode ? 'text' : 'password'}
                  autoComplete="off"
                  spellCheck="false"
                  value={unlockCode}
                  onChange={(e) => setUnlockCode(e.target.value)}
                  placeholder="Enter code"
                  aria-label="Access code"
                  required
                />
                <button
                  type="button"
                  className="adminLogin__iconBtn"
                  onClick={() => setShowUnlockCode((v) => !v)}
                  aria-label={showUnlockCode ? 'Hide security code' : 'Show security code'}
                >
                  {showUnlockCode ? 'Hide' : 'Show'}
                </button>
              </div>
            </label>

            <div className="adminLogin__checkboxRow">
              <label className="adminLogin__checkbox">
                <input
                  type="checkbox"
                  checked={trustThisDevice}
                  onChange={(e) => setTrustThisDevice(e.target.checked)}
                />
                <span>Trust this device for 30 days</span>
              </label>
            </div>

            <button className="adminLogin__submit" type="submit" disabled={loading}>
              {loading ? 'Checking…' : 'Verify access'}
            </button>
          </form>

          <footer className="adminLogin__footer">
            <RouterLink className="adminLogin__secondaryLink" to={adminPath(ADMIN_PATHS.SUPPORT_LOGIN)}>
              Support employee? Use Support Login
            </RouterLink>
          </footer>
        </section>
      </main>
    </div>
  );
}
